export default __webpack_public_path__ + "static/media/head-banner.0169019a.png";